import { Box, Typography } from '@mui/material';
import React from 'react';

const StorePageHeader = ({ title, imgSrc, imgLeft, backgroundColor, borderRadius }) => {
  const boxStyle = imgSrc
    ? {
        backgroundSize: 'cover',
        backgroundPosition: '0, 0',
        backgroundRepeat: 'no-repeat',
        backgroundImage: `url(${imgSrc})`,
        minHeight: '500px',
      }
    : {
        backgroundColor: 'white',
      };

  return (
    <Box style={boxStyle}>
      <Box
        sx={{
          display: 'inline-block',
          width: 'fit-content',
          maxWidth: '100%',
        }}>
        <Box
          sx={{
            background: '#FFDE00',
            padding: '0.8rem 1.8rem 0.8rem',
            borderBottomRightRadius: '0px',
            width: 'fit-content',
            maxWidth: '100%',
            minWidth: '20rem',
          }}>
          <Typography variant="h1" sx={{ lineHeight: 1.3, display: 'inline' }}>
            {title}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default StorePageHeader;
